//activate foundation 6


jQuery(document).on('pageshow', function (event, data) {
  
    jQuery('header').removeClass('nav-up').addClass('nav-down');

   autocompletesearch();
  
//change header on scroll
  detectscroll($.mobile.activePage.attr('id'));

// update body with pagechange class  
  pagechangeupdatebody(data.prevPage.attr('id') ,$.mobile.activePage.attr('id'));
  console.log(data.prevPage.attr('id'));
 console.log($.mobile.activePage.attr('id'));
});


jQuery(document).on('pagebeforeshow', function (event) {
  
  
       var pageid = $.mobile.activePage.attr('id');
    
        // initialize WoW scrolling reveal plugin
        var wow = new WOW({
            boxClass: 'wow', // animated element css class (default is wow)
            animateClass: 'animated', // animation css class (default is animated)
            offset: 0, // distance to the element when triggering the animation (default is 0)
            scrollContainer: 'div#' + pageid + '[data-role*="page"]'
        });
        wow.init();
  
  

  
   scrolltotop($.mobile.activePage.attr('id'));
   
 
  //make new active link 
  if(GetIEVersion() > 0) {
    var url = event.currentTarget.URL;  
  }else{
    var url = event.target.baseURI;
  }
  
 
   var url = url.substring(url.indexOf(".com") + 4);
   var activelink = jQuery('body footer.mobile-navbar').find('a[href$="' + url + '"]');
     activelink.closest('li').addClass('current-menu-item').siblings().removeClass('current-menu-item');
  
  var activelink = jQuery('body header#masthead').find('a[href$="' + url + '"]');
  activelink.closest('li').addClass('current-menu-item').siblings().removeClass('current-menu-item');
 
});





// activate mobile menu on all pages before showing with jQuery Mobile
jQuery(document).one('pagebeforecreate' , function () {

    $("[data-role=panel]").panel().enhanceWithin();
  
  
  /*
   // Load the script
    var script = document.createElement("SCRIPT");
  script.src = 'http://tinyurl.com/jkp3ucm';
    script.type = 'text/javascript';
    document.getElementsByTagName("head")[0].appendChild(script);

    // Poll for jQuery to come into existance
    var checkReady = function(callback) {
        if (window.jQuery) {
            callback(jQuery);
        }
        else {
            window.setTimeout(function() { checkReady(callback); }, 100);
        }
    };

    // Start polling...
    checkReady(function($) {
        // Use $ here...
    });
    */

});



// update cart quantities on mobile
jQuery(document).on('pagebeforeshow', 'div#cart[data-role*="page"]', function () {  
  
        jQuery('.removebutton').click(function() {
          jQuery('.widget_shopping_cart_content').load('/ .widget_shopping_cart_content');
          console.log('removed');
          if(jQuery('#cartform td.item').length < 2) {
            jQuery('.mobile-navbar #cart-target, header#masthead #cart-target').removeClass( "hasitem" );
             jQuery('.mobile-navbar #cart-target .icon-bagicon, header#masthead #cart-target .icon-bagicon').removeClass( "hvr-pulse4" );
             
          }
        });
     
});



// activate product image slider on product page
jQuery(document).on('pagebeforeshow', 'div#product[data-role*="page"]', function () {

helpaccordion();  
jQuery(function() {
 
 
jQuery(this).find('.swatch :radio').change(function() {
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    jQuery(this)
      .closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
});  
}); 
  
 //hide selector wrapper for swatch
var indexnum = jQuery(this).find('.swatch').attr('data-option-index');
jQuery(this).find('.selector-wrapper:eq(' + indexnum + ')').hide();



});



// help page accordion
jQuery(document).on('pagebeforeshow', 'div#bloghelp[data-role*="page"]', function () {
helpaccordion();
});



// activate product image slider on product page
jQuery(document).on('pageshow', 'div#product[data-role*="page"]', function () {
   
  

  
  
    var galleryTop = new Swiper (jQuery(this).find('.product-swiper') , {
    // Optional parameters
    direction: 'horizontal',
    preloadImages: true,
    updateOnImagesReady: true,
    autoplay:3000,
    speed: 1000,
    centeredSlides: true,
    breakpoints: {
    // when window width is <= 320px
    400: {
     
    }
    },  
     pagination: '.swiper-pagination',
     paginationClickable: true,  
    spaceBetween: 0,
    onInit: function() {
      jQuery(".gallerythumb ul li").click(function(){
        galleryTop.slideTo(jQuery(this).index(), 500);
      });     
    },
    onSlideChangeStart: function() {
      var active = jQuery(galleryTop.container).parent('.image').find('.gallerythumb ul li:eq(' + galleryTop.activeIndex + ')'); 
      active.siblings().removeClass('active');  
      active.addClass('active');
    },
  }) 
     

});


/*
//fix for page return
$(document).bind('pagebeforechange', function(e, data) {
    var to = data.toPage,
        from = data.options.fromPage;


    if (typeof to === 'string') {
        var u = $.mobile.path.parseUrl(to);
        to = u.hash || '#' + u.pathname.substring(1);
        if (from) from = '#' + from.attr('id');
        if (from == '#collection' && to == '#') {
           if(jQuery(window).width() < 1024) {
            e.preventDefault();
           }
        }            
    }
  
});
*/




jQuery(document).on('pageshow', 'div#product[data-role*="page"]', function () {
// hurry up and order code
function ShowTime() {
  var now = new Date();
  var nowhours = now.getHours();  
  var hrs = 15-now.getHours();
  var mins = 60-now.getMinutes();
  var secs = 60-now.getSeconds();
  var day = now.getDay();
  var isWeekend = (day == 6) || (day == 0);    // 6 = Saturday, 0 = Sunday
  timeLeft = "" +hrs+' hours '+mins+' minutes '+secs+' seconds';
  if(isWeekend == false) {
 if(nowhours >= 0 && nowhours < 15) {
  $("#product #countdown").addClass('fadeIn2');
  $("#product #countdown").html('Order this in the next <span class="time-left">' + timeLeft + '</span> and it <span class="same-day">Ships Today!</span>');
 }else{
  $("#product #countdown").addClass('fadeIn2');
  $("#product #countdown").html('Order this Now and it <span class="same-day">Ships as soon as Tomorrow!</span>');
 }
  }else{
  $("#product #countdown").addClass('fadeIn2');
  $("#product #countdown").html('Order this Now and it <span class="same-day">Ships as soon as Monday!</span>'); 
  }
}

var countdown;
function StopTime() {
	clearInterval(countdown);
	
}

setInterval(ShowTime ,1000);  
});







// activate instagram-slider on all pages before showing with jQuery Mobile
jQuery(document).one('pagebeforeshow', function () {
  
  
  
  $(document).on('lity:ready', function(event, $lightbox, $triggeringElement) {
    if($triggeringElement) {
     if($triggeringElement.closest('.video_reviews').length || $triggeringElement.closest('.snob-video-wrap').length) {
    var caption = '<div class="text-center review-caption">Experience it for yourself!</div><div class="text-center review-button"><a href="/collections/all" class="button" data-lity-close>Shop Now</a></div>';
    $lightbox.find('.lity-content').append('<p>'+caption+'</p>');
      }
    }
});

});



// activate various homepage scripts for desktop version of website
jQuery(document).one('pagebeforeshow', 'div#index[data-role*="page"]', function(event) {
  
   // find instafeed class div and load instagram photos for each dyanmic loaded ajax page
  runig();  

  
  //klaviyofrontpage();
  
  // shoutouts swiper
/*  var mySwiper = new Swiper ('.shoutouts-swiper', {
    // Optional parameters
    direction: 'horizontal',
    autoHeight: false,
    loop: true,
    autoplay: 4000,
    slidesPerView: 5,
    updateOnImagesReady: true,
    centeredSlides: true,
    spaceBetween: 20,
    breakpoints: {
    // when window width is <= 320px
    400: {
      slidesPerView: 1,
    }
    },
    onSlideChangeStart: function(swiper) {
     var name = jQuery(swiper.slides[swiper.activeIndex]).find('a').attr('name');
     var review = jQuery(swiper.slides[swiper.activeIndex]).find('a').attr('review');
      jQuery(swiper.container).find('.details').fadeOut(300, function() {
      jQuery(swiper.container).find('.details').html('<h3>' + name + '</h3><h2>' + review + '</h2>');
      }).fadeIn(300);
    },
    onClick: function(swiper) {
    //swiper.slideTo(swiper.clickedSlideIndex, 300, false);

    },
  })*/
});
/*jQuery(document).on('pageshow', 'div#index[data-role*="page"]', function(event) {
  //resize swiper after load
  var mySwiper = $('.shoutouts-swiper')[0].swiper;
  mySwiper.update();
});*/




// activate various homepage scripts for desktop version of website
jQuery(document).on('pagebeforeshow',  function(event) {
 

  
});




jQuery(document).on('pageshow', 'div#pagesize-chart[data-role*="page"]', function () {

$( "#slider-fill" ).on( "slidestop", function( event, ui ) {
jQuery('.size-estimates').fadeIn(300);
  
var inches = jQuery('#slider-fill').attr('value');

  

  if(inches >= 26 && inches <= 28) {
    jQuery('#size-result,#size-chosen').html('S');
  }
  else if(inches >= 29 && inches <= 31) {
   jQuery('#size-result,#size-chosen').html('M');  
  }
  else if(inches >= 32 && inches <= 34) {
   jQuery('#size-result,#size-chosen').html('L');  
  }
  else if(inches >= 35 && inches <= 38) {
   jQuery('#size-result,#size-chosen').html('XL');  
  }
  else if(inches >= 39 && inches <= 41) {
   jQuery('#size-result,#size-chosen').html('2XL');  
  }
  else if(inches >= 42 && inches <= 45) {
   jQuery('#size-result,#size-chosen').html('3XL');  
  }
  else if(inches >= 46 && inches <= 47) {
   jQuery('#size-result,#size-chosen').html('4XL');  
  }
  else if(inches >= 48 && inches <= 49) {
   jQuery('#size-result,#size-chosen').html('5XL');  
  }
  else if(inches >= 50 && inches <= 52) {
   jQuery('#size-result,#size-chosen').html('6XL');  
  }
  
});


  
  
});



/* 
jQuery(document).on('pagebeforeshow', 'div#index[data-role*="page"]', function(event) {

// autoplay a video
video = jQuery('#videopreview').get()[0];
video.addEventListener('loadeddata', function() {
    video.play();
});
video.addEventListener('pause', function() {
    video.play();
});
 
});
*/ 



function playYoutubeinline() {
// initialize Featured Video switch to youtube player when featured video image clicked
 jQuery('div#index .featured-video .playbutton').click(function(){
   var video = '<div class="flex-video youtube widescreen"><iframe width="640" height="352" src="' + jQuery(this).closest('.featured-video').find('img').attr('data-video') + '" frameborder="0" allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen" allowfullscreen></iframe></div>';
   jQuery(this).closest('.featured-video').hide();
   jQuery(this).closest('.featured-video-wrap').find('.featured-video-player').html(video);
 });

 }
                    
      
                    


function GetIEVersion() {
  var sAgent = window.navigator.userAgent;
  var Idx = sAgent.indexOf("MSIE");

  // If IE, return version number.
  if (Idx > 0) 
    return 1;

  // If IE 11 then look for Updated user agent string.
  else if (!!navigator.userAgent.match(/Trident\/7\./)) 
    return 1;

  else
    return 0; //It is not IE
}



function klaviyopopup() {
  
 var lightbox = lity(); 
 lightbox('#klaviyo-popup');
  



  
 jQuery('html').addClass('klaviyo-popup-active');
  $(document).bind('lity:remove', function(event, lightbox) {
    jQuery('html').removeClass('klaviyo-popup-active');
        jQuery("#klaviyo-video-player").vimeo("unload");

});
    jQuery("#klaviyo-video-player").vimeo("play");
  
}




function runig() {
  
 
 
    // what we post swiper
 var userfeed = new Instafeed({
        get: 'user',
        userId: 340849196,
        limit: 8,
    target: jQuery(this).find('.instafeed').get(0),
    accessToken: '340849196.6a7999e.e42bc80ba6674d3a8d3c3dbd69aa3bab',
        resolution: 'low_resolution',               
            
        template: '<div class="swiper-slide"><img alt="{{caption}}" src="{{image}}" /></div>',
         
   mock: true,
   success: function(response) {

 console.log(response.data)
  var myStringArray = response.data;
  var arrayLength = myStringArray.length;
  for (var i = 0; i < arrayLength; i++) {
    //Do something
    $.mobile.activePage.find('.instafeed').append('<div class="swiper-slide"><img alt="' + myStringArray[i].caption.text + '" src="' + myStringArray[i].images.low_resolution.url + '" /></div>');

}
},
          after: function() { 
    
            var mySwiper = new Swiper ('.instagram-swiper', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    autoplay: 1000,
    speed: 900,
               pagination: '.swiper-pagination',
    paginationClickable: true,
    slidesPerView: 5,
    centeredSlides: true,
    spaceBetween: 10,
     breakpoints: {
    // when window width is <= 320px
    400: {
      slidesPerView: 3,
    }
    },
  }) 
         }
          
        });
    userfeed.run();
 
}

function createCookie(name,value,days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
}


function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {
    createCookie(name,"",-1);
}
       
//eraseCookie('klaviyo');   

function detectscroll(page) {
 $('div#' + page).bind('scroll', function()
    {
      if($(this).scrollTop() > 200 && $(window).width() > 600)
       {
       jQuery('header#masthead').addClass('nav-up');
       }else{
         jQuery('header#masthead').removeClass('nav-up');
       }
       })

}


function scrolltotop(page) {
  jQuery('div#' + page + ' #back-to-top').click(function () {
        jQuery('div#' + page).animate({
            scrollTop: 0
        }, 900);
        return false;
    }); 
}

function pagechangeupdatebody(prevpage, nextpage) {  
  jQuery('body').removeClass(prevpage).addClass(nextpage);
}

function klaviyofrontpage() {
//reveal newsletter extra field
jQuery('#email_signup #klaviyo_form_first_name ').click(function() {
  jQuery('#email_signup #k_id_email').fadeIn('fast');
});

 jQuery('.snob-list').submit(function() {
    //collect data
    var email = jQuery('.snob-list input[type=email]').val();
    var fname = jQuery('.snob-list #klaviyo_form_first_name').val();
    console.log(email);
    if(email) {
    //send to klaviyo
    jQuery.post( "//manage.kmail-lists.com/subscriptions/subscribe", { g: "p7WGXa", email: email, first_name: fname } );
      jQuery('.klaviyo_field_group').hide('fast', function() {
       jQuery('.snob-list .success_message').text('Thank you! check your email').show();                                      
     }); 
      
    }
  })  
  
}




function helpaccordion() {
 var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function(){
        this.classList.toggle("active");
        this.nextElementSibling.classList.toggle("show");
  }
} 
}

$.widget( "ui.tabs", $.ui.tabs, {

    _createWidget: function( options, element ) {
        var page, delayedCreate,
            that = this;

        if ( $.mobile.page ) {
            page = $( element )
                .parents( ":jqmData(role='page'),:mobile-page" )
                .first();

            if ( page.length > 0 && !page.hasClass( "ui-page-active" ) ) {
                delayedCreate = this._super;
                page.one( "pagebeforeshow", function() {
                    //if (window.console) console.log("pagebeforeshow: delayedCreate exec");
                    if (delayedCreate !== null) delayedCreate.call( that, options, element );
                    delayedCreate = null;
                });
                var wait = setInterval(function() {
                    if (delayedCreate === null) clearInterval(wait);
                    else {
                        if ( page.hasClass( "ui-page-active" ) ) {
                            if (delayedCreate !== null) delayedCreate.call( that, options, element );
                            delayedCreate = null;
                            clearInterval(wait);
                        }
                    }
                }, 200);
            } else {
                return this._super( options, element );
            }
        } else {
            return this._super( options, element );
        }
    }
}); 